import React from "react";
import { connect } from "react-redux";
import { Button , NavDropdown } from "react-bootstrap";
import { changeLanguage } from "./../../actions";

const LanguageSelector = (props) => {
  return (
    <NavDropdown title="Language" id="basic-nav-dropdown">
      <NavDropdown.Item as={Button} onClick={()=>{props.changeLanguage("en-US")}} >English</NavDropdown.Item>
      <NavDropdown.Item as={Button} onClick={()=>{props.changeLanguage("zh-CN")}} >汉语</NavDropdown.Item>
    </NavDropdown>
  );
}

const mapStateToProps = (state) => {
  return { language: state.userSettings.language}
}

export default connect(mapStateToProps, { changeLanguage })(LanguageSelector);